const getOverriddenSections = (state: AnyFixMe) => state.designPanel.overridden;
const getShowCustomizeDesignOnly = (state: AnyFixMe) =>
  state.designPanel.showCustomizeDesignOnly;

export { getOverriddenSections, getShowCustomizeDesignOnly };
